import React from "react";
import { useSelector } from "react-redux";

import { CouponFilterPage } from "./couponFilter/CouponFilterPage";
import { CouponTablePage } from "./couponTable/CouponTablePage";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import classes from "./couponListPage.module.css";

import {
  selectCoupons,
  useGetCouponsListQuery,
} from "../../services/coupon/couponApiSlice";

import { selectCouponFilter } from "../../store/couponFilterSlice";

export const CouponListPage = () => {
  const { status, search } = useSelector(selectCouponFilter);

  // ✅ send BOTH search and status
  const { isSuccess, isFetching } = useGetCouponsListQuery({
    search,
    status,
  });

  const tableData = useSelector(selectCoupons);

  if (!isSuccess || isFetching) {
    return <CategoryPageSkeleton />;
  }

  return (
    <div className={classes.box}>
      <CouponFilterPage />
      <CouponTablePage data={tableData} />
    </div>
  );
};
